import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import useAuth from 'components/auth/useAuth'
import { Carousel } from 'components'
import { RegistrationForm } from '../forms'
import * as apiActions from 'api-actions'
import { API_KEY_MAP } from 'types'
import { PATH, makeMarketingSitePath, makeMemberPortalPath } from 'config'
import {
  apiValuesWithMappedKeys,
  forceMemberPortalReload,
  withApiAuth,
} from 'utils'

const propTypes = {
  verifyMembership: PropTypes.func.isRequired,
}

function ExistingMemberRegistration({ verifyMembership }) {
  const { logout, user } = useAuth()
  const { state } = useLocation()
  const history = useHistory()

  const registrationFailureUrl = makeMemberPortalPath(
    PATH.REGISTRATION,
    PATH.ERROR,
  )

  const newMembershipUrl = makeMemberPortalPath(PATH.MEMBER_APPLICATION)

  // If we have no Auth0 user available, registration cannot continue...
  if (!user) {
    return <Redirect to={registrationFailureUrl} />
  }

  const { sub: auth0UserId } = user
  const failRegistration = () => history.replace(registrationFailureUrl, state)
  const navigateToJoin = () => history.replace(newMembershipUrl)

  return (
    <div className="auth">
      <div className="modal">
        <div className="ReactModal__Overlay ReactModal__Overlay--after-open modal-fade-screen">
          <div className="modal-inner auth-card">
            <header>
              <img src="/assets/images/logo-color.svg" alt="Sea Tow" />
              <h2>Register</h2>
              <Carousel>
                <img
                  src="/assets/images/login-card.png"
                  alt="Sea Tow Membership Card"
                  className="registration-image"
                />
                <img
                  src="/assets/images/login-apple-wallet.png"
                  alt="Sea Tow Membership Card with Apple Wallet"
                  className="registration-image"
                />
                <img
                  src="/assets/images/login-google-wallet.png"
                  alt="Sea Tow Membership Card with Google Wallet"
                  className="registration-image"
                />
                <img
                  src="/assets/images/login-email.png"
                  alt="Sea Tow email footer with Membership Number and Expiration Date"
                  className="registration-image"
                />
                <img
                  src="/assets/images/login-care-center.png"
                  alt="Customer Care Contact Info"
                  className="registration-image"
                />
              </Carousel>
            </header>
            <RegistrationForm
              cancel={() =>
                logout({
                  logoutParams: {
                    returnTo: makeMarketingSitePath(PATH.SEATOW_LOGOUT),
                  },
                })
              }
              joinHandler={navigateToJoin}
              onSubmit={(registrationFormValues) => {
                const registrationApiValues = apiValuesWithMappedKeys(
                  registrationFormValues,
                  API_KEY_MAP.REGISTRATION_KEY_MAP,
                )

                return verifyMembership({
                  ...registrationApiValues,
                  auth0_user_id: auth0UserId,
                })
              }}
              onSubmitSuccess={() => forceMemberPortalReload(state?.returnTo)}
              onSubmitFail={failRegistration}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ExistingMemberRegistration.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {}

const mapApiAuthToProps = {
  verifyMembership: apiActions.verifyMembership,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApiAuth(mapApiAuthToProps),
)(ExistingMemberRegistration)
